"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Processing = void 0;
var bson_1 = require("bson");
var Processing = /** @class */ (function () {
    function Processing(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.processing, processing = _c === void 0 ? false : _c, _d = _a.origin, origin = _d === void 0 ? '' : _d, _e = _a.loteAtual, loteAtual = _e === void 0 ? 0 : _e, _f = _a.loteFim, loteFim = _f === void 0 ? 0 : _f, _g = _a.error, error = _g === void 0 ? '' : _g, _h = _a.login, login = _h === void 0 ? '' : _h;
        this._id = _id;
        this.processing = processing;
        this.origin = origin;
        this.loteAtual = loteAtual;
        this.loteFim = loteFim;
        this.error = error;
        this.login = login;
    }
    return Processing;
}());
exports.Processing = Processing;
//# sourceMappingURL=Processing.js.map